import { BaseCoreGameCommunicationProcessor } from '@pp/core/src/controllers/gameCommunication/processors/BaseCoreGameCommunicationProcessor';
import { GameCommunicationMessageType } from '@pp/core/src/controllers/gameCommunication/types';

import { GameStore } from '../../../store/GameStore';
import { highflyerGameStateActions } from '../../../store/slices/highflyerGame/slice';

type gameResult = {
  gameEncryptedResult: string;
  gameHashKey: string;
  gameId: string;
  gameResult: number;
  gameType: string;
  resultTime: string;
};

type statisticHistoryMsg = GameCommunicationMessageType & {
  errorCode: string;
  description: string;
  history: gameResult[];
  numberOfGames: number;
  seq: number;
};

export class GameCommunicationManStatisticHistoryProcessor extends BaseCoreGameCommunicationProcessor {
  messageName = 'HighFlyerStatisticHistory';
  delay = 0;

  process(message: statisticHistoryMsg, store: GameStore): void {
    const processDelay: number = 0;

    setTimeout(() => {
      this.handleBetsStats(message, store);
    }, processDelay);
  }

  private handleBetsStats(message: statisticHistoryMsg, store: GameStore): void {
    store.dispatch(highflyerGameStateActions.setRecentResults(message));
  }
}
